import React from 'react';
import { makeStyles, Typography, Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import ErrorIconCircle from '../../svg/ErrorIconCircle';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F9F9FA',
    borderRadius: theme.spacing(0.5),
    borderLeft: '4px solid',
    borderLeftColor: '#D34343',
    padding: theme.spacing(2, 3, 2, 2.5),
    flexDirection: 'column',
  },
  errorIcon: {
    marginRight: theme.spacing(3),
    width: '32px',
    height: '32px',
  },
  errorMessageTitle: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.25,
  },
  errorMessage: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.25,
  },
}));

const IdVerificationErrorAlert = ({
  errorMessage,
  idVerificationResult,
  isVerifyIdPrefilledError,
}) => {
  const classes = useStyles();
  const getDisplayErrorMessage = () => {
    if (!errorMessage) {
      return null;
    }

    const verificationResultCode = idVerificationResult
      ? idVerificationResult.verificationResultCode
      : '';
    if (isVerifyIdPrefilledError && verificationResultCode === 'N') {
      return {
        errorTitle: 'We could not verify your identity with the details provided to us',
        errorBody: 'Please complete the required information in order to proceed',
      };
    }

    if (verificationResultCode === 'N') {
      return {
        errorTitle: 'We could not verify your identity',
        errorBody:
          'Please check that all information exactly matches your identity document before trying again',
      };
    }

    if (verificationResultCode === 'D') {
      return {
        errorTitle: 'We could not verify your identity',
        errorBody:
          'Your identity document could not be verified. Please try a different identity document.',
      };
    }

    if (verificationResultCode === 'S') {
      return {
        errorTitle: 'We could not verify your identity',
        errorBody: 'Please try again later or try using a different identity document.',
      };
    }

    return {
      errorTitle: 'We could not verify your identity',
      errorBody: 'Please try again later.',
    };
  };

  const displayError = getDisplayErrorMessage();

  const alertBody = displayError ? (
    <Grid item xs={12}>
      <Box
        className={classes.root}
        borderRadius="borderRadius"
        display="flex"
        alignItems="flex-start"
        data-testid="uia-alert-idverification"
      >
        <Box display="flex" alignItems="flex-start">
          <ErrorIconCircle className={classes.errorIcon} />
          <Box>
            <Typography className={classes.errorMessageTitle}>{displayError.errorTitle}</Typography>
            <Typography className={classes.errorMessage}>{displayError.errorBody}</Typography>
          </Box>
        </Box>
      </Box>
    </Grid>
  ) : null;
  return alertBody;
};

IdVerificationErrorAlert.propTypes = {
  errorMessage: PropTypes.string,
  idVerificationResult: PropTypes.object,
  isVerifyIdPrefilledError: PropTypes.bool,
};

export default IdVerificationErrorAlert;
